export default __webpack_public_path__ + "static/media/baking.43000173.png";